module.exports = __webpack_public_path__ + "static/img/Gallery07.aa6c80a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls46-1/Gallery07.jpg
// module id = lS5Q
// module chunks = 12